import { Component, Input, OnInit } from '@angular/core';
import { AgentService } from '@core/services/agent.service';
import { CommonService } from '@core/services/common.service';
import { UserService } from '@core/services/user.service';
import { InactiveProduct } from '@shared/models/inactive-product';
import { User } from '@shared/models/user';

@Component({
    selector: 'app-special-offer',
    templateUrl: './special-offer.component.html',
    styleUrls: ['./special-offer.component.scss'],
    standalone: false
})
export class SpecialOfferComponent implements OnInit {
  @Input() product: InactiveProduct;

  private loggedUser: User;
  constructor(
    private agentService: AgentService,
    private userService: UserService,
    private commonService: CommonService
  ) {
    this.userService.getLoggedUser().subscribe(x => this.loggedUser = x);
  }

  ngOnInit(): void {
  }

  openLink(url: string, t = false): void {

    if (this.loggedUser.prefferedAgent == null && t == true) {
      this.commonService.openPrefferedAgentModal(url);
      return;
    }

    if ((this.loggedUser.prefferedAgent != null || this.loggedUser.prefferedAgent.agentId != null) && t == true) {
      this.agentService.getPrefferedAgentToken(this.loggedUser.prefferedAgent.agentNo).subscribe(token => {
        window.open(url + '?agent=' + token['token'], '_blank');
      });
    } else {
      window.open(url, '_blank');
    }
  }

}
